import ApiService from "./api.service";

const prepareFormSearch = function (form) {
  let query = {}
  query.status = form.status;
  query.company = form.company;
  query.from = form.range_date.start;
  query.to = form.range_date.end;
  if (form.owners.length > 0) {
    query.owners = [];
    for (let i = 0, n = form.owners.length; i < n; i++) {
      query.owners.push(form.owners[i].value);
    }
  }
  // if (data.status.length > 0) {
  //   query.status = data.status;
  // }
  return query;
}

const Opos = {
  search: async function (form) {
    let response = await ApiService.get("/opos", prepareFormSearch(form));
    return response.data.opos;
  },
};

export default Opos;